import Icon from "react-native-vector-icons/MaterialCommunityIcons"
import * as Colors from "../../../styles/colors"
import * as Fonts from "../../../styles/typography"
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { DelVehicle } from "../../../services/Api/vehicles";
import { formatMoneyBRL } from "../../../helpers/util";
import BillItem from "./BillItem";
import ButtonIcon from "../../../components/ButonIcon";

export default function Bill({ data, onPress, hasIcon = false }) {

    return (
        <View style={styles.principalView}>
            <View style={styles.infoView}>
                <BillItem iconName={"file-document"} value={data.nossoNumero} />
                <BillItem iconName={"calendar-alert"} value={data.dueDate} />
            </View>
            <View style={styles.infoView}>
                <BillItem iconName={"calendar-month-outline"} value={data.reference} />
                <BillItem iconName={""} value={formatMoneyBRL(data.value)} highlith={true} />
            </View>
            <View style={{marginLeft: "auto"}}>
            {hasIcon ? <ButtonIcon colorButton={Colors.SUCCESS} iconName={"currency-usd"} onPress={onPress}/> : null}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    principalView: {
        flexDirection: "row",
        borderRadius: 8,
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 8,
        padding: 8,
        backgroundColor: Colors.SNOW,
        borderColor: Colors.SECONDARY,
        borderLeftWidth: 2,
        shadowColor: Colors.GRAY_DARK,
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        borderRadius: 8,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    infoView: {
        marginLeft: 8,
    },
    titleText: {
        fontSize: Fonts.FONT_SIZE_20,
        fontWeight: "300",
        color: Colors.BLACK,
    },
    plateText: {
        fontSize: Fonts.FONT_SIZE_18,
        fontWeight: "500",
        color: Colors.SECONDARY,
    },
})